import React, {Component} from 'react'

class Box extends Component {
	constructor(...args) {
        super(...args)
		
		this.state = {}
	}

	getNumberFormat(value,digit) {
		let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
		_val = parseFloat(_val)
		if (digit==='0') {
			return Math.ceil(_val).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
		} else {	
			return _val.toFixed(digit).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
		}	
	}
	
	onBoxDown(e) {
		if (this.props.onBoxDown!==undefined)
			this.props.onBoxDown(e.keyCode)
	}

	onBoxActive(id,action) {
		if (this.props.onBoxActive!==undefined&&id===undefined) {
			this.props.onBoxActive()
			document.body.style.overflow = 'hidden';
		} else if (this.props.onItemDeleteClick!==undefined&&id!==undefined&&action==='delete') {
			this.props.onItemDeleteClick(id)
			document.body.style.overflow = 'auto';
		} else if (this.props.onExpandClick!==undefined&&id!==undefined&&action==='expand') {
			this.props.onExpandClick(id)
			document.body.style.overflow = 'auto';
		}	
	}

	onBoxBlur() {
		if (this.props.onBoxBlur!==undefined) {
			this.props.onBoxBlur()
			document.body.style.overflow = 'auto';
		}
	}

	onBoxDbClick() {
		if (this.props.onBoxDbClick!==undefined) {
			this.props.onBoxDbClick()
			document.body.style.overflow = 'auto';
		}
	}

	render() {
		const {id,title,field,isActive,showField,isArray,width,text_align,digit} = this.props
		let padding = '0.5rem 1rem'
		if ((width!==undefined&&width!=='auto')&&((text_align!==undefined||text_align!=='center'))) {
			if (text_align==='left')
				padding = '0.5rem 1.5rem 0.5rem 0.5rem'
			else if (text_align==='right')
				padding = '0.5rem 0.5rem 0.5rem 1.5rem'
		} 	
		return(
			<div 
				className='box-item' 
				id={'box-item-'+id} 
				tabIndex='1' 
				onBlur={this.onBoxBlur.bind(this)} 
				onKeyDown={this.onBoxDown.bind(this)} 
				style={{width:(width!==undefined?width:'auto'),textAlign:(text_align!==undefined?text_align:'center'),padding:padding,outline:'none',backgroundColor:isActive===id?'#ADD8E6':'',border:isActive===id?'1px dashed blue':'none',cursor:'move',position:'relative'}}
			>
				{isActive===id?<div style={{position:'absolute',right:'0',top:'-17px',cursor:'pointer'}} onClick={this.onBoxActive.bind(this,id,'delete')}>[x]</div>:''}
				<div onDoubleClick={this.onBoxDbClick.bind(this)} onClick={this.onBoxActive.bind(this,undefined)}>{showField?<span>{field} </span>:''}{digit!==undefined&&digit!==''&&digit!==null&&!isNaN(digit)?this.getNumberFormat(title,digit):title}</div>
				{isActive===id&&isArray?<div style={{position:'absolute',right:'0',bottom:'-17px',cursor:'pointer'}} onClick={this.onBoxActive.bind(this,id,'expand')}>[+]</div>:''}
			</div>
		)
	}
}
export default Box;


// WEBPACK FOOTER //
// ./src/view/print/paperconfig/Box.js